import LW_POS_BLACK from '../assets/bb-bg-img.png'
import LW_POS_WHITE from '../assets/bb-bg-img.png'
import LW_LOGO_BLACK from '../assets/lw-logo-black.png'
import LW_LOGO_WHITE from '../assets/lw-logo-white.png'
import LW_LOGIN_PAGE_BANNER from '../assets/login-page-banner3.png'
import BB_BACKGROUND_IMGH from '../assets/bb-bg-img.png'
import RUCHI_VEDIKA_LOGO from '../assets/ruchi-vedika-logo.png'

const NO_IMAGE_URL =
  'https://firebasestorage.googleapis.com/v0/b/bill-desk-fb37f.appspot.com/o/files%2FgotnoImage.jpg?alt=media&token=c4d1f907-c38c-4bf2-82c5-af4165204624'

export {
  LW_POS_BLACK,
  LW_POS_WHITE,
  NO_IMAGE_URL,
  LW_LOGO_BLACK,
  LW_LOGO_WHITE,
  LW_LOGIN_PAGE_BANNER,
  BB_BACKGROUND_IMGH,
  RUCHI_VEDIKA_LOGO
}
